import React, { PropsWithChildren } from "react";
import { useAuthService } from "./AuthProvider";

const AuthBoundary: React.FC<PropsWithChildren> = ({ children }) => {
  const { authState } = useAuthService();

  return authState ? children : null;
};

export default AuthBoundary;
